import _ from 'lodash';

type SniGroup =
	| 'A'
	| 'B'
	| 'C'
	| 'D'
	| 'E'
	| 'F'
	| 'G'
	| 'H'
	| 'I'
	| 'J'
	| 'K'
	| 'L'
	| 'M'
	| 'N'
	| 'O'
	| 'P'
	| 'Q'
	| 'R'
	| 'S'
	| 'T'
	| 'U'
	| 'V';

const SNI_GROUP_RANGES: Record<SniGroup, [number, number]> = {
	A: [0, 4000],
	B: [5000, 10000],
	C: [10000, 34000],
	D: [35000, 35999],
	E: [36000, 40000],
	F: [41000, 44000],
	G: [46000, 48000],
	H: [49000, 54000],
	I: [55000, 57000],
	J: [58000, 60999],
	K: [61000, 63999],
	L: [64000, 67000],
	M: [68000, 68999],
	N: [69000, 76000],
	O: [77000, 83000],
	P: [84000, 84999],
	Q: [85000, 85999],
	R: [86000, 89000],
	S: [90000, 93999],
	T: [94000, 96999],
	U: [97000, 98999],
	V: [99000, 100000]
};

export type OrgNumberMap2025 = {
	id: SniGroup;
	name: string;
	gte: number;
	lt: number;
	codes: string[];
	isInGroup: (sniCode: number) => boolean;
};

const extractCodesFromRange = ([min, max]: [number, number]): string[] => {
	const minCode = Math.floor(min / 1000);
	const maxCode = Math.floor((max - 1) / 1000);

	const codes: string[] = [];
	for (let i = minCode; i <= maxCode; i++) {
		codes.push(i.toString());
	}
	return codes;
};

const createIsInGroupFunction = (codes: string[]): ((sniCode: number) => boolean) => {
	if (codes.length === 1) {
		const singleCode = parseInt(codes[0]);
		return (sniCode: number) => sniCode === singleCode;
	}

	const minCode = parseInt(codes[0]);
	const maxCode = parseInt(codes[codes.length - 1]) + 1;
	return (sniCode: number) => _.inRange(sniCode, minCode, maxCode);
};

const createOrgNumberMapEntry = (id: SniGroup, range: [number, number]): OrgNumberMap2025 => {
	const [gte, lt] = range;
	const codes = extractCodesFromRange(range);
	const isInGroup = createIsInGroupFunction(codes);

	return {
		id,
		name: `default.sni2025group${id}`,
		gte,
		lt,
		codes,
		isInGroup
	};
};

const ORG_NUMBER_MAP_2025: OrgNumberMap2025[] = (Object.keys(SNI_GROUP_RANGES) as SniGroup[]).map(key =>
	createOrgNumberMapEntry(key, SNI_GROUP_RANGES[key])
);

export default ORG_NUMBER_MAP_2025;
